export const environment = {
	env: 'development',
	intercomAppId: 'ssl1wxqp',
	production: true,
	googleMapsAPIKey: 'AIzaSyC4OOpkzFJ-6WFzRHcBqG-H7XYOjxs7iaI',
	stripePublishableAPIKey: 'pk_test_51J5Kh0EgCSMDz09z954E4iv4eg7sLGMT7uLao43bHcwhO3fZSGsQfVD5OW5KMOfIkWHMqTY2K8FDm1UWjyLzG4ea00an4BitbW',
	colors: {
		primary0: '#0EABF7',
		primary: '#078BCB',
		primary2: '#067ab2',
		primary3: '#05699a',
		accentWhite: '#eff6ff',
		accent1: '#bfdbfe',
		accent2: '#60a5fa',
		lightPrimary: '#339bff26',
		//primary-5% opacity
		primary5: '#078BCB0D',
	},
	stripePlans: [
		{ plan: 'Business', key: { monthly: 'price_1QjAMtEgCSMDz09ztH9w47q6', yearly: 'price_1QjCGoEgCSMDz09zasMAwUHO' } },
	],
	posthog: true,
	countries: ['australia', 'new zealand'],
	us: false,
	baseUrl: 'https://dev.paintprojex.com',
	obiKey: '25e030eb-1db5-4629-8849-d3afda65d19f',
	currency: {
		code: 'AUD',
		symbol: '$',
		locale: 'en-AU'
	},
	defaultTimezone: 'Australia/Brisbane',
};
